import { stringify } from 'qs';
import request from '@/services/request';
import { url } from './service-utils';

/**
 * 页面：总课表详情
 * 前端：洪芳
 * 后端： 陈新
 */
export async function classDetail(params) {
  return request(`${url.url}/course/term/class/detail?${stringify(params)}`);
}

/**
 * 页面：保存导入组件id
 * 前端：洪芳
 * 后端： 陈新
 */
export async function setAssemble(params) {
  return request(`${url.url}/course/term/set-assemble/${params.id}`, {
    method: 'put',
    data: params,
  });
}
